import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const [showSignIn, setShowSignIn] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setShowSignIn(false);
  };

  return (
    <>
      <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white pt-20 pb-10">
        <div className="max-w-7xl mx-auto px-6">
          {/* Main Footer Content */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-16">
            {/* Brand Column */}
            <div className="lg:col-span-1">
              <Link to="/" className="text-3xl font-bold mb-6 inline-block cursor-pointer">
                Your App Wizard
              </Link>
              <p className="text-gray-400 leading-relaxed mb-6 max-w-sm text-sm">
                Build stunning iOS and Android apps without code. The most powerful and easiest app builder for entrepreneurs and creators.
              </p>
              <div className="flex items-center gap-4">
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer nofollow" className="w-10 h-10 bg-gray-800 hover:bg-cyan-600 rounded-lg flex items-center justify-center transition-all cursor-pointer hover:scale-110">
                  <i className="ri-twitter-x-line text-lg"></i>
                </a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer nofollow" className="w-10 h-10 bg-gray-800 hover:bg-cyan-600 rounded-lg flex items-center justify-center transition-all cursor-pointer hover:scale-110">
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer nofollow" className="w-10 h-10 bg-gray-800 hover:bg-cyan-600 rounded-lg flex items-center justify-center transition-all cursor-pointer hover:scale-110">
                  <i className="ri-instagram-line text-lg"></i>
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer nofollow" className="w-10 h-10 bg-gray-800 hover:bg-cyan-600 rounded-lg flex items-center justify-center transition-all cursor-pointer hover:scale-110">
                  <i className="ri-linkedin-fill text-lg"></i>
                </a>
              </div>

              {/* Corporate Headquarters */}
              <div className="mt-8">
                <h4 className="font-bold text-base mb-3 text-white">Corporate Headquarters</h4>
                <div className="text-gray-400 text-sm leading-relaxed space-y-1">
                  <a
                    href="https://businessdevelopmentauthority.net/"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="text-cyan-400 hover:text-cyan-300 font-semibold transition-colors cursor-pointer block"
                  >
                    Business Development Authority Inc
                  </a>
                  <p>725 E Road 2 N Unit 1494</p>
                  <p>Chino Valley, AZ 86323</p>
                </div>
              </div>
            </div>

            {/* Product Column */}
            <div>
              <h4 className="font-bold text-lg mb-6">Product</h4>
              <ul className="space-y-3">
                <li><Link to="/features" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm">Features</Link></li>
                <li><Link to="/templates" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm">Templates</Link></li>
                <li><Link to="/pricing" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm">Pricing</Link></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm">Changelog</a></li>
                <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm">About</Link></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm">Blog</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm">Careers</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm">Contact</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm">Community</a></li>
                <li>
                  <a
                    href="https://www.amazon.com/stores/Jeffery-Long/author/B0D6LTDYD5?ref=ap_rdr&isDramIntegrated=true&shoppingPortalEnabled=true&ccs_id=043cae77-eaa8-440d-8b65-2edc56fe7c65"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="text-cyan-400 hover:text-cyan-300 transition-colors cursor-pointer text-sm flex items-center gap-1.5"
                  >
                    <i className="ri-amazon-line text-base"></i>
                    Author Page
                  </a>
                </li>
              </ul>
            </div>

            {/* Services Column */}
            <div>
              <h4 className="font-bold text-lg mb-6">Corp Services</h4>
              <ul className="space-y-3">
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm">AI Strategy Consulting</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm">Process Automation</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm">Machine Learning Solutions</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm">Digital Transformation</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm">AI Implementation</a></li>
              </ul>
            </div>

            {/* Author Page Column */}
            <div>
              <h4 className="font-bold text-lg mb-6">Corporate Holdings</h4>
              <ul className="space-y-3">
                <li>
                  <a href="https://businessdevelopmentauthority.net/" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm">
                    Business Development Authority Portfolio
                  </a>
                </li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm">Travel Authority</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm">AI Consulting Authority</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm">AI Book Authority</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm">Real Estate Development Authority</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm">Real Estate Development &amp; eXp</a></li>
              </ul>
            </div>
          </div>

          {/* Member Sign In Banner */}
          <div className="bg-gradient-to-r from-cyan-500/10 to-teal-500/10 border border-cyan-500/20 rounded-2xl px-8 py-6 mb-10 flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 flex items-center justify-center bg-cyan-500/20 rounded-full">
                <i className="ri-user-line text-cyan-400 text-lg"></i>
              </div>
              <div>
                <p className="text-white font-semibold text-sm">Already a member?</p>
                <p className="text-gray-400 text-xs">Sign in to access your dashboard and continue building.</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <button
                onClick={() => { setIsSignUp(false); setShowSignIn(true); }}
                className="px-6 py-2.5 border border-cyan-500/50 text-cyan-400 hover:bg-cyan-500/10 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap hover:scale-105"
              >
                Sign In
              </button>
              <button
                onClick={() => { setIsSignUp(true); setShowSignIn(true); }}
                className="px-6 py-2.5 bg-gradient-to-r from-cyan-500 to-teal-500 text-white rounded-lg text-sm font-medium hover:from-cyan-600 hover:to-teal-600 transition-all cursor-pointer whitespace-nowrap hover:scale-105 shadow-lg shadow-cyan-500/20"
              >
                Create Account
              </button>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-8 border-t border-gray-800">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <p className="text-gray-400 text-sm">
                © {currentYear} Your App Wizard. All rights reserved.
              </p>
              <div className="flex items-center gap-6">
                <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">Privacy Policy</a>
                <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">Terms of Service</a>
                <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">Cookie Policy</a>
                <button
                  onClick={() => { setIsSignUp(false); setShowSignIn(true); }}
                  className="text-cyan-400 hover:text-cyan-300 text-sm transition-colors cursor-pointer flex items-center gap-1.5 whitespace-nowrap"
                >
                  <i className="ri-login-box-line"></i>
                  Member Sign In
                </button>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Sign In Modal */}
      {showSignIn && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm"
          onClick={(e) => { if (e.target === e.currentTarget) setShowSignIn(false); }}
        >
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-hidden">
            {/* Modal Header */}
            <div className="bg-gradient-to-r from-cyan-500 to-teal-500 px-8 py-8 text-white text-center relative">
              <button
                onClick={() => setShowSignIn(false)}
                className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-lg"></i>
              </button>
              <div className="text-3xl font-bold mb-1">Your App Wizard</div>
              <p className="text-white/80 text-sm">{isSignUp ? 'Create your account' : 'Welcome back'}</p>
            </div>

            {/* Toggle Tabs */}
            <div className="flex border-b border-gray-100">
              <button
                onClick={() => setIsSignUp(false)}
                className={`flex-1 py-3.5 text-sm font-semibold transition-colors cursor-pointer ${!isSignUp ? 'text-cyan-600 border-b-2 border-cyan-500' : 'text-gray-400 hover:text-gray-600'}`}
              >
                Sign In
              </button>
              <button
                onClick={() => setIsSignUp(true)}
                className={`flex-1 py-3.5 text-sm font-semibold transition-colors cursor-pointer ${isSignUp ? 'text-cyan-600 border-b-2 border-cyan-500' : 'text-gray-400 hover:text-gray-600'}`}
              >
                Create Account
              </button>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit} className="px-8 py-7 space-y-4">
              {isSignUp && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">Full Name</label>
                  <input
                    type="text"
                    placeholder="John Doe"
                    className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-cyan-400 focus:border-transparent transition"
                  />
                </div>
              )}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">Email Address</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                  className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-cyan-400 focus:border-transparent transition"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">Password</label>
                <div className="relative">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                    required
                    className="w-full border border-gray-200 rounded-lg px-4 py-2.5 pr-10 text-sm focus:outline-none focus:ring-2 focus:ring-cyan-400 focus:border-transparent transition"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer w-5 h-5 flex items-center justify-center"
                  >
                    <i className={showPassword ? 'ri-eye-off-line' : 'ri-eye-line'}></i>
                  </button>
                </div>
              </div>
              {!isSignUp && (
                <div className="text-right">
                  <a href="#" className="text-xs text-cyan-600 hover:underline cursor-pointer">Forgot password?</a>
                </div>
              )}
              <button
                type="submit"
                className="w-full py-3 bg-gradient-to-r from-cyan-500 to-teal-500 text-white rounded-lg font-semibold text-sm hover:from-cyan-600 hover:to-teal-600 transition-all shadow-lg shadow-cyan-500/30 hover:scale-[1.02] cursor-pointer whitespace-nowrap mt-2"
              >
                {isSignUp ? 'Create Account' : 'Sign In to Your App Wizard'}
              </button>

              <div className="relative flex items-center gap-3 py-1">
                <div className="flex-1 h-px bg-gray-100"></div>
                <span className="text-xs text-gray-400">or continue with</span>
                <div className="flex-1 h-px bg-gray-100"></div>
              </div>

              <div className="grid grid-cols-2 gap-3">
                <button type="button" className="flex items-center justify-center gap-2 border border-gray-200 rounded-lg py-2.5 text-sm text-gray-600 hover:bg-gray-50 transition cursor-pointer whitespace-nowrap">
                  <img src="https://www.google.com/favicon.ico" alt="Google" className="w-4 h-4" />
                  Google
                </button>
                <button type="button" className="flex items-center justify-center gap-2 border border-gray-200 rounded-lg py-2.5 text-sm text-gray-600 hover:bg-gray-50 transition cursor-pointer whitespace-nowrap">
                  <i className="ri-github-fill text-gray-800 text-base"></i>
                  GitHub
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
